import React from "react";
import { createPortal } from "react-dom";

import "./backdrop.styles.scss";

export type DropdownBackdropProps = {
  isCreatePortal: boolean;
};

export const DropdownBackdrop = ({ isCreatePortal }: DropdownBackdropProps) => {
  
  const handleClose = React.useCallback(() => {
    if(document.body) {
      document.body.click();
    }
  }, []);
    
  const component = (
    <div
      onClick={handleClose}
      className="DropdownBackdrop"
    />
  );

  return isCreatePortal ? createPortal(component, document.body) : component;
};
